import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button as RbButton, Form, Card } from 'react-bootstrap';
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';
const uuid = require('uuid');

const ServerRequest = require('../../actions/request');
const ActivityActions = require('../../actions/ActivityActions');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    show: PropTypes.bool,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    closeHandler: PropTypes.func.isRequired,
    importStacks: PropTypes.array,
};

const defaultProps = {
    show: false,
    importStacks: [],
};

class StackImportProjectModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            devImportStack: '',
            devImportError: '',
            devImportSourceProjectId: '',
            devImportActivityPrefix: 'Project Import of ',
            devImportPublishedOnly: true,
            previewData: null,
        };
    }

    // import dev tool functions
    setImportStack=(stackName)=>{
        this.setState({
            devImportStack: stackName,
            devImportError: '',
            previewData: null,
        });
    }

    setImportSourceProjectId=(e)=>{
        this.setState({
            devImportSourceProjectId: e.target.value,
            devImportError: '',
            previewData: null,
        });
    }

    setImportActivityPrefix=(e)=>{
        this.setState({
            devImportActivityPrefix: e.target.value,
        });
    }

    setImportPublishedOnly=(e)=>{
        this.setState({
            devImportPublishedOnly: e.target.checked,
            devImportError: '',
            previewData: null,
        });
    }

    doImport=()=>{
        let url = '/authoring/import_project';
        const isPreview = !this.state.previewData;
        const project_id = Number(this.state.devImportSourceProjectId);
        ServerRequest.makeRequest(url, 'POST', JSON.stringify({
                stack: this.state.devImportStack,
                sourceProjectID: project_id,
                destProjectID: this.props.projectId,
                activityPrefix: this.state.devImportActivityPrefix,
                publishedOnly:  this.state.devImportPublishedOnly,
                previewOnly: this.state.previewData ? false : true,
            }))
            .then((results) => {
                console.log("import results.",results);
                if (isPreview) {
                    this.setState({previewData:results});
                }
                else {
                    ActivityActions.getProjectActivities(uuid.v4(), { projectId: this.props.projectId, channelId: this.props.channelId });
                    this.props.closeHandler();
                }
            })
            .catch((err) => {
                console.log("import error",err);
                this.setState({
                    devImportError: err.responseText
                });
            });
    }

    isPositiveInteger=(str)=>{
        var n = Math.floor(Number(str));
        return n !== Infinity && String(n) === str && n >= 0;
    }

    render() {
        if (!this.props.importStacks || this.props.importStacks.length === 0) {
            return null;
        }
        
        let disabled = !this.state.devImportStack || !this.isPositiveInteger(this.state.devImportSourceProjectId);
        if (this.state.previewData && !this.state.previewData.numActivities) {
            disabled = true; // disable if there are no activites
        }

        return (
            <Modal
                className='import-modal'
                show
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>Dev Project Import (EXPERIMENTAL)</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorBox
                        error={this.state.devImportError ? { message: this.state.devImportError } : null}
                    />
                    <Form>
                        <Form.Group>
                            <Wrapper className='AriaMenuButton inline-block' onSelection={this.setImportStack}>
                                <Button className="AriaMenuButton-trigger flat-button primary btn-width2">
                                    {this.state.devImportStack || 'select stack'}
                                </Button>
                                <Menu>
                                    <ul className='AriaMenuButton-menu'>
                                        {this.props.importStacks.map((stackName) =>
                                            <li className='AriaMenuButton-menuItemWrapper' key={stackName}>
                                                <MenuItem className="AriaMenuButton-menuItem" value={stackName} text={stackName}>
                                                    {stackName}
                                                </MenuItem>
                                            </li>
                                        )}
                                    </ul>
                                </Menu>
                            </Wrapper>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Source Project ID</Form.Label>
                            <Form.Control
                                type="text"
                                htmlSize={10}
                                maxLength={10}
                                onChange={this.setImportSourceProjectId}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Imported Activity Prefix</Form.Label>
                            <Form.Control
                                type="text"
                                defaultValue={this.state.devImportActivityPrefix}
                                bsPrefix={'form-control visible-spaces'}
                                onChange={this.setImportActivityPrefix}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Check checked={this.state.devImportPublishedOnly} onChange={this.setImportPublishedOnly} label="Published Only"/>
                            <Form.Text muted>
                                {this.state.devImportPublishedOnly ? "Import published activities only" : "Import all activities in project"}
                            </Form.Text>
                        </Form.Group>
                        <Card body bg="light">
                            { this.state.previewData ? 
                            <div className="project-import-preview">
                                <label>{'Source Project Name:'}</label><span>{this.state.previewData.projectName}</span>
                                <label>{'Activities found:'}</label><span>{this.state.previewData.numActivities}</span>
                            </div>
                            : null }
                        </Card>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <RbButton disabled={disabled} onClick={this.doImport}>
                        {this.state.previewData ? "Proceed with Import" : "Preview Import"}
                    </RbButton>
                </Modal.Footer>
            </Modal>
        );
    }
}

StackImportProjectModal.propTypes = propTypes;
StackImportProjectModal.defaultProps = defaultProps;

export default StackImportProjectModal;